import { PdNoticeBox } from "./PdNoticeBox.js";
//#region src/pd-notice-box/pd-notice-box.ts
var tag = "pd-notice-box";
if (!customElements.get(tag)) customElements.define(tag, PdNoticeBox);
//#endregion
export { PdNoticeBox };
